import Navbar from '@components/Navbar'
import styled from 'styled-components'

const NavbarWrapper = styled.div`
  > div {
    margin: 0 0 calc(var(--navbar-height) * -1);
  }

  .mb-8 {
    margin-bottom: 8px !important;
  }
`

const CaseStudyLayout: React.FC = ({ children }) => (
  <>
    <style jsx global>{`
      button,
      a {
        margin: unset !important;
      }

      .slide-show-slider-temp {
        margin: 12rem 0;
      }

      @media (max-width: 992px) {
        .slide-show-slider-temp {
          margin: 4rem 0 6rem;
        }
      }
    `}</style>
    <NavbarWrapper>
      <Navbar staticLinks theme="white" />
    </NavbarWrapper>
    {children}
  </>
)

export default CaseStudyLayout
